import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  nsSeparator: false,
  keySeparator: false,
  lng: "sr",
  fallbackLng: "en",
  resources: {
    en: { translation: require("./locales/en.json") },
    sr: { translation: require("./locales/sr.json") },
  },
});

export default i18n;
